var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGym(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0083 46.4119C36.401 46.4119 46.4473 36.3656 46.4473 23.9729C46.4473 11.5802 36.401 1.53394 24.0083 1.53394C11.6156 1.53394 1.56934 11.5802 1.56934 23.9729C1.56934 36.3656 11.6156 46.4119 24.0083 46.4119Z",
    fill: "#374151"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7823 32.8496H12.9092C12.3264 32.8496 11.8496 32.3728 11.8496 31.79V15.7251C11.8496 15.1423 12.3264 14.6655 12.9092 14.6655H14.7823C15.3651 14.6655 15.8419 15.1423 15.8419 15.7251V31.79C15.8419 32.3728 15.3651 32.8496 14.7823 32.8496Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5214 29.2269H9.91835C9.48523 29.2269 9.13086 28.8725 9.13086 28.4394V18.9887C9.13086 18.5555 9.48523 18.2012 9.91835 18.2012H10.5214C10.9545 18.2012 11.3089 18.5555 11.3089 18.9887V28.4394C11.3089 28.8725 10.9545 29.2269 10.5214 29.2269Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.92943 25.5177H7.44785C6.98132 25.5177 6.59961 25.136 6.59961 24.6695V22.5853C6.59961 22.1188 6.98132 21.7371 7.44785 21.7371H7.92943C8.39596 21.7371 8.77767 22.1188 8.77767 22.5853V24.6695C8.77767 25.136 8.39596 25.5177 7.92943 25.5177Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0303 32.8496H33.9034C34.4862 32.8496 34.963 32.3728 34.963 31.79V15.7251C34.963 15.1423 34.4862 14.6655 33.9034 14.6655H32.0303C31.4475 14.6655 30.9707 15.1423 30.9707 15.7251V31.79C30.9707 32.3728 31.4475 32.8496 32.0303 32.8496Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2904 29.2269H36.8935C37.3266 29.2269 37.681 28.8725 37.681 28.4394V18.9887C37.681 18.5555 37.3266 18.2012 36.8935 18.2012H36.2904C35.8573 18.2012 35.5029 18.5555 35.5029 18.9887V28.4394C35.5029 28.8725 35.8573 29.2269 36.2904 29.2269Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8824 25.5177H39.364C39.8305 25.5177 40.2122 25.136 40.2122 24.6695V22.5853C40.2122 22.1188 39.8305 21.7371 39.364 21.7371H38.8824C38.4159 21.7371 38.0342 22.1188 38.0342 22.5853V24.6695C38.0342 25.136 38.4159 25.5177 38.8824 25.5177Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7865 24.9458H17.0845C16.9155 24.9458 16.7773 24.8076 16.7773 24.6387V22.0442C16.7773 21.8753 16.9156 21.7371 17.0845 21.7371H29.7865C29.9555 21.7371 30.0937 21.8753 30.0937 22.0442V24.6387C30.0937 24.8076 29.9555 24.9458 29.7865 24.9458Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGym);
export default __webpack_public_path__ + "static/media/gym.bb80771abe706f77599b7770ea002cc3.svg";
export { ForwardRef as ReactComponent };